/**
 * Update specific user properties in Mixpanel
 */
const updateUserProperties = updates => {
  if (!window.mixpanel) return;
  const people = {
    ...updates
  };
  if (updates.email) people.$email = updates.email;
  if (updates.firstName) people.$first_name = updates.firstName;
  if (updates.lastName) people.$last_name = updates.lastName;
  if (updates.phone) people.$phone = updates.phone;
  if (!people.$name && (updates.firstName || updates.lastName)) {
    people.$name = `${updates.firstName ?? ''} ${updates.lastName ?? ''}`.trim();
  }
  // Avoid duplicating non-reserved and reserved versions
  delete people.firstName;
  delete people.lastName;
  delete people.phone;
  delete people.email;
  window.mixpanel?.people?.set?.(people);
};
/**
 * Store user session context (called on page load)
 */
const storeSessionContext = (sessionData = {}) => {
  if (!window.mixpanel) {
    return;
  }
  try {
    const contextData = {
      'First Visited URL': window.location.href,
      'First Visited Path': window.location.pathname,
      'User Agent': navigator.userAgent,
      'Screen Resolution': `${screen.width}x${screen.height}`,
      'Viewport Size': `${window.innerWidth}x${window.innerHeight}`,
      Language: navigator.language,
      Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      Referrer: document.referrer,
      Timestamp: new Date().toISOString(),
      ...sessionData
    };
    window.mixpanel.register(contextData);
  } catch (error) {
    console.error('[Mixpanel] Error storing session context:', error);
  }
};

export { storeSessionContext, updateUserProperties };
